export const ORDER_DETAIL_V2_ASSETS = {
  TRIP_SECURED_ICON:
    "https://tripmoneycmsimgak.mmtcdn.com/img/trip_Secured_9a14d8e25c.svg",
  PLAN_COVERAGE_ICON:
    "https://tripmoneycmsimgak.mmtcdn.com/img/P_and_C_Icon_3x_59fc3a881e.png",
  PRIMARY_CONTACT_ICON:
    "https://tripmoneycmsimgak.mmtcdn.com/img/Primary_Contact_Icon_3x_9a81d8e8f4.png",
  MAIL_ICON:
    "https://tripmoneycmsimgak.mmtcdn.com/img/mail_Icon_cf3395e217.svg",
  CALL_ICON:
    "https://tripmoneycmsimgak.mmtcdn.com/img/call_Icon_94b21de941.svg",
  VALIDATION_ERROR_ICON:
    "https://tripmoneycmsimgak.mmtcdn.com/img/Leading_Icon_Swap_62bf92f616.svg",
  SUCCESS_ICON:
    "https://tripmoneycmsimgak.mmtcdn.com/img/No_Trailing_Icon_a5c58b394f.svg",
} as const;

export const ORDER_DETAIL_V2_URLS = {
  MY_TRIPS: "https://supportz.makemytrip.com/Mima/BookingSummary/",
} as const;

export const ORDER_STATUS = {
  UPCOMING: "UPCOMING",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
} as const;

export type OrderStatus = typeof ORDER_STATUS[keyof typeof ORDER_STATUS];
